import { React, useEffect, useState } from 'react';
// import entryVideo from './../../img/Fair_Entry.mp4';
import style from './auth.module.scss';
import { useHistory } from 'react-router-dom';
import { DoubleRightOutlined } from '@ant-design/icons';
import { LoadingTable } from '../utils/Utils';

const FairEntry = () => {
  const history = useHistory();
  const [endEntry, setEndEntry] = useState(false);
  const [videoSkiped, setVideoSkiped] = useState(false);

  useEffect(() => {
    const video = document.getElementById('entryVideo');
    video.addEventListener('ended',vidEnded);
    return () => {
      video.removeEventListener('ended',vidEnded);
    };
  }, []);

  const vidEnded = () => {
    setEndEntry(true);
    setTimeout(() => {
      history.push('/');
    }, 750);
  };

  const skipVideo = () => {
    setVideoSkiped(true);
    setTimeout(() => {
      history.push('/');
    }, 750);
  };
  const entryVideo = `${process.env.REACT_APP_PUBLIC_ASSETS}/public/Fair_Entry.mp4`;
  return (
    <>
      <div className={style.entryFairVidContainer}>
        <div className={style.loadingEntry}>
          <LoadingTable color="white"/>
        </div>
        <div className={style.videoMaskStart}></div>
        {(endEntry || videoSkiped) && <div className={style.videoMaskEnd}></div>}
        <video id='entryVideo' autoPlay muted style={{zIndex: '1'}}>
          <source src={entryVideo} type="video/mp4" />
        </video>
      </div>
      <div>
        <button className={style.videoBtn} onClick={skipVideo}>
          <span>
            Saltar intro
            <DoubleRightOutlined />
          </span>
        </button>
      </div>
    </>
  );
};

export default FairEntry;
